// extracted by mini-css-extract-plugin
module.exports = {"UsageScenariosA":"UsageScenariosA_UsageScenariosA__nFg5_"};